"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MathUtil {
    static add(a, b) {
        return a + b;
    }
    static compare(a, b) {
        return ((a < b) ? -1 :
            (a == b) ? 0 :
                1);
    }
    static floorMod(a, b) {
        return ((a % b) + b) % b;
    }
    static rotate(array, distance) {
        while (distance-- > 0) {
            array.push(array.shift());
        }
    }
    static clamp(min, max, value) {
        if (max < min) {
            throw new Error("max should not be less than min");
        }
        return Math.max(min, Math.min(max, value));
    }
}
exports.default = MathUtil;
